module.exports = __webpack_public_path__ + "static/media/githubicon.fa954d74.svg";